module.exports = __webpack_public_path__ + "static/step2-8307498be5dd4893aff1b92baae8492b.png";